import React, { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { api } from "@/lib/api";

let cache = null;
// The course bought most this calendar month (paid, not refunded), shared across pages.
export const usePopularCourse = () => {
  const [p, setP] = useState(cache);
  useEffect(() => { if (!cache) api.get("/courses/popular").then(({ data }) => { cache = data; setP(data); }).catch(() => {}); }, []);
  return p;
};

export const PopularBadge = ({ testId }) => (
  <span className="inline-flex items-center gap-1 rounded-full bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground" data-testid={testId}>
    <Flame size={12} /> Most popular this month
  </span>
);

export const PopularLine = () => {
  const p = usePopularCourse();
  if (!p?.course_key) return null;
  return <p className="mt-3 inline-flex items-center gap-2 text-sm" data-testid="pricing-popular"><PopularBadge testId="pricing-popular-badge" /> {p.label}</p>;
};
